import { useState, useEffect } from 'react';

const BASE_URL = 'https://api.dev.auxo.dk/public/content';

export const useContent = (collectionName) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${BASE_URL}/${collectionName}`);
        if (!response.ok) {
          throw new Error(`Failed to fetch ${collectionName}`);
        }
        const result = await response.json();
        setData(result.items || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [collectionName]);

  return { data, loading, error };
};
